import { Flex } from 'modules/ui';
import { BodyText } from 'modules/ui/typography';
import styled from 'styled-components';

export const EurContainer = styled(BodyText)`
  font-weight: bold;
  line-height: normal;
  margin-bottom: 0.2rem;
  word-break: break-all;
`;

export const Container = styled(Flex)`
  flex-direction: column;
  justify-content: space-around;
`;
